import { render } from "./basicModal.vue?vue&type=template&id=55102a74"
import script from "./basicModal.vue?vue&type=script&lang=js"
export * from "./basicModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__